import React, { useLayoutEffect, useRef, useState } from "react";
import classes from "./BoardMember.module.css";

const BoardMember = (props) => {
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);
  const textRef = useRef(null);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (el) {
      setOverflowing(el.scrollHeight > el.clientHeight + 1);
    }
  }, [props.children]);

  return (
    <article className={classes.BoardMember}>
      <div className={classes.Info}>
        <div
          className={classes.Photo}
          style={{ backgroundImage: `url(${props.image})` }}
        ></div>
        <div>
          <h3 className={classes.Name}>{props.name}</h3>
          <span className={classes.Role}>{props.role}</span>
          <div className={classes.Contact}>
            {props.mail ? (
              <a className={classes.ContactItem} href={`mailto:${props.mail}`}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                {props.mail}
              </a>
            ) : null}

            {props.phone ? (
              <a className={classes.ContactItem} href={`tel:${props.phone}`}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                {props.phone}
              </a>
            ) : null}
          </div>
        </div>
      </div>
      <p
        ref={textRef}
        className={`${classes.Text} ${expanded ? "" : classes.Clamped}`}
      >
        {props.children}
      </p>
      {overflowing || expanded ? (
        <button
          type="button"
          className={classes.Toggle}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Weniger anzeigen" : "Mehr anzeigen"}
        </button>
      ) : null}
    </article>
  );
};

export default BoardMember;
